import { render } from "./NameRedirect.vue?vue&type=template&id=afc67c48&scoped=true&ts=true"
import script from "./NameRedirect.vue?vue&type=script&lang=ts"
export * from "./NameRedirect.vue?vue&type=script&lang=ts"

import "./NameRedirect.vue?vue&type=style&index=0&id=afc67c48&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afc67c48"]])

export default __exports__